<template>
  <div
    v-show="totalNumber > 0"
    class="select"
    :class="{'select-collapsed': !sidebarExpandedProp}"
  >
    <p class="selected">
      {{ this.totalNumber }} {{ $lang.messages.expensesSelected }}
    </p>
    <button class="action-btn" @click="showPayExpenseModal()">
      <span>{{ $lang.messages.pay }}</span>
    </button>
    <p class="total">
      {{ $lang.messages.totalToPay }}:
      <span>
        <currency-sign :currency="currency"></currency-sign>{{ currencyFormat(totalAmount) }}
      </span>
    </p>
  </div>
</template>

<script>
    import CurrencySign from "@/components/common/CurrencySign"
    import { currencyFormat } from "@/mixins/currencyFormat";

    export default {
      name: "FpSelect",
      components: {
        CurrencySign
      },
      mixins: [
        currencyFormat
      ],
      props: {
        totalNumber: {
          required: true,
          type: Number,
          default: 0
        },
        sidebarExpandedProp: {
          type: Boolean,
          default: false
        },
        totalAmount : {
          required: true,
          type: Number,
          default: 0
        }
      },
      data() {
        return {
          rerender: 0,
          currency: localStorage.getItem('currency') ? localStorage.getItem('currency').substr(1, localStorage.getItem('currency').length - 2) : ''
        }
      },
      methods: {
        showPayExpenseModal() {
          this.$emit('showTotalPayments');
        }
      }
    }
</script>
